import { SimpleEventRegistrantsPage } from '@/components/admin/events/SimpleEventRegistrantsPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(SimpleEventRegistrantsPage, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
